var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseThick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.707 3.293a1 1 0 0 1 .069 1.338l-.069.076L9.415 8l3.292 3.293a1 1 0 0 1-1.338 1.483l-.076-.069L8 9.415l-3.293 3.292a1 1 0 0 1-1.483-1.338l.069-.076L6.585 8 3.293 4.707a1 1 0 0 1 1.338-1.483l.076.069L8 6.585l3.293-3.292a1 1 0 0 1 1.414 0"
})));
export default SvgCloseThick;